module.exports = __webpack_public_path__ + "static/img/bg_6.0c22155.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/bg_6.png
// module id = 788
// module chunks = 1